import { Audio, VolumeDown, VolumeMute, VolumeUp } from '@tunasong/icons'
import {  Typography, isMobileDevice, Grid, Slider} from '@tunasong/ui-lib'
import type { FC } from 'react'
import { AudioController } from './engine/audio-controller.js'
import { Meter } from './meter.js'
import styles from './volume.module.css'

export interface VolumeProps {
  title?: string
  controller: AudioController
  onChange?(value: number): void
  onClose?(): void
}

export const Volume: FC<VolumeProps> = props => {
  const { controller, onChange, onClose, title = 'Volume' } = props

  const handleVolume = (ev: unknown, value: number | number[]) => {
    if (typeof value !== 'number') {
      return
    }

    controller.gain = value
    if (onChange) {
      onChange(value)
    }
  }

  const handleMute = () => {
    controller.muted = !controller.muted
  }

  const handleMonitor = (val: boolean) => () => {
    // eslint-disable-next-line react-compiler/react-compiler
    controller.monitor = val
    if (!isMobileDevice()) {
      controller.enableDSPFeatures(val)
    }
  }

  const handleMax = (ev: unknown) => handleVolume(ev, 1)

  return (
    <div className={styles.container}>
      <Typography gutterBottom variant="caption">
        {title}
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 1 }}>
          {controller.type === 'mic' ? (
            controller.monitor ? (
              <Audio color="var(--tuna-palette-warning-main)" onClick={handleMonitor(false)} />
            ) : (
              <Audio onClick={handleMonitor(true)} />
            )
          ) : null}
        </Grid>

        <Grid size={{ xs: 1 }}>
          {controller.muted ? <VolumeMute color="var(--tuna-palette-error-main)" onClick={handleMute} /> : <VolumeDown onClick={handleMute} />}
        </Grid>
        <Grid className={styles.sliderGrid} size={{ xs: 9 }}>
          <Slider
            className={styles.slider}
            disabled={controller.muted}
            value={controller.gain}
            step={0.01}
            min={0.0}
            max={1.0}
            onChange={handleVolume}
            onChangeCommitted={onClose ? () => onClose() : undefined}
          />
          <Meter controller={controller} at="pre" />
          {controller.trackType === 'bus' ? <Meter controller={controller} at="post" color="primary" /> : null}
        </Grid>
        <Grid size={{ xs: 1 }}>
          <VolumeUp onClick={handleMax} />
        </Grid>
      </Grid>
    </div>
  )
}

export default Volume
